import React, { useState } from 'react';
import './contactform.css';
import axios from "axios";

function ContactForm() {
    // State pour stocker les valeurs des champs
    const [formData, setFormData] = useState({
        nomPrenom: '',
        adresse: '',
        email: '',
        telephone: '',
        service: '',
        details: '',
    });

    // Fonction pour mettre à jour les valeurs
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value, // Associe le nom du champ à sa valeur
        });
    };

    // Soumission du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault(); // Empêche le rechargement de la page

        const backendUrl =  'https://fpsbackend.vercel.app'

        try {
            const response = await axios.post(
                `${backendUrl}/api/message`,
                formData,
                {
                    headers: {
                        'Content-Type': 'application/json', // Spécifie que la requête envoie un JSON
                        'Access-Control-Allow-Origin': '*', // Permet l'accès depuis n'importe quelle origine
                    },
                }
            );

            if (response.status === 200) {
                setFormData({
                    nomPrenom: "",
                    adresse: "",
                    email: "",
                    telephone: "",
                    service: "",
                    details: "",
                }); // Réinitialise les champs du formulaire
            } else {
            }
        } catch (error) {
            console.error("Erreur lors de l'envoi :", error);
                    }
    };


    return (
        <div className="form-container">
            <h1>Commencer le processus</h1>
            <form onSubmit={handleSubmit}>
                <div className="input-group">
                    <label htmlFor="nom-prenom">Nom et Prénom :</label>
                    <input
                        type="text"
                        id="nom-prenom"
                        name="nomPrenom"
                        value={formData.nomPrenom}
                        onChange={handleInputChange}
                        required
                    />
                </div>
                <div className="input-group">
                    <label htmlFor="adresse">Ville/Adresse exacte :</label>
                    <input
                        type="text"
                        id="adresse"
                        name="adresse"
                        value={formData.adresse}
                        onChange={handleInputChange}
                        required
                    />
                </div>
                <div className="input-group">
                    <label htmlFor="email">Adresse e-mail :</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />
                </div>
                <div className="input-group">
                    <label htmlFor="telephone">Numéro de téléphone :</label>
                    <input
                        type="tel"
                        id="telephone"
                        name="telephone"
                        value={formData.telephone}
                        onChange={handleInputChange}
                        required
                    />
                </div>
                <div className="input-group">
                    <label htmlFor="service">Sélectionnez un service :</label>
                    <select
                        id="service"
                        name="service"
                        value={formData.service}
                        onChange={handleInputChange}
                        required
                    >
                        <option value="">-- Sélectionnez un service --</option>
                        <option value="asile">Demande d'asile</option>
                        <option value="titre-sejour">Titre de séjours</option>
                        <option value="naturalisation">Naturalisation</option>
                        <option value="nationalite-francaise">Demande de nationalité Française</option>
                        <option value="visa">Demande de Visa</option>
                        <option value="prolongation-visa">Prolongation de Visa</option>
                        <option value="demande-administrative">Demande administrative (état civil, mariage...)</option>
                        <option value="contestation-oqtf">Contestation OQTF, IRTF</option>
                        <option value="regroupement-familial">Regroupement familial</option>
                        <option value="droit-travail-etranger">Droit de travail pour étranger</option>
                        <option value="assistance-juridique">Assistance juridique (divorce, droit de garde, conflit, dette...)</option>
                        <option value="tutelle-tuteur">Tutelle-tuteur, droit à la retraite</option>
                    </select>
                </div>
    <div className="input-group">
        <label htmlFor="telephone">Plus de détails :</label>
        <textarea
            type="details"
            id="details"
            name="details"
            value={formData.details}
            onChange={handleInputChange}
            required
        />
    </div>
                <button type="submit">Envoyer ma demande</button>
            </form>
            {/*/!* Affiche les données pour le débogage (optionnel) *!/*/}
            {/*<div>*/}
            {/*    <h2>Debug:</h2>*/}
            {/*    <pre>{JSON.stringify(formData, null, 2)}</pre>*/}
            {/*    <div>*/}
            {/*        <h1>Application React avec Backend Node.js</h1>*/}
            {/*        <p>{message}</p>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    );
}

export default ContactForm;
